module.exports = __webpack_public_path__ + "img/404-error.dfb1a19b.svg";